export default __webpack_public_path__ + "static/media/DOLLAR_2.76820c2c.webm";